import { render } from "./ExercisesPage.vue?vue&type=template&id=17b4415a"
import script from "./ExercisesPage.vue?vue&type=script&lang=js"
export * from "./ExercisesPage.vue?vue&type=script&lang=js"

import "./ExercisesPage.vue?vue&type=style&index=0&id=17b4415a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__